module.exports = __webpack_public_path__ + "media/assets/images/authors/giacomo_macri-7877d610eb6252781e843026d9c3eec1.jpg";